import React, { useEffect, useState } from 'react';
import { useIntl } from 'react-intl';
import { SidePanel, SidePanelBody, SidePanelHeader, SidePanelFooter, Button, Loading } from '@gpstrackit/gtc-react-controls';
import { useDispatch, useSelector } from 'react-redux';

import { openModalRouteDirections } from './redux/slice';
import './style.scss';

import DirectionsMap from '../../../../../../components/Map/components/DirectionsMap'
import { setMapRoutesOptions } from 'Redux/actions';

const ModalMarkerRouteDirections = (props) => {

    const { data, mapRef } = props

    const { messages, locale } = useIntl();

    const dispatch = useDispatch();

    const handleModalMaker = () => {
        dispatch(openModalRouteDirections({ open: false }))
    }
    const openModal = useSelector(state => state.routesManagedDirectionRedux?.open);
    const openModalMarkerInfo = useSelector(state => state.routesManagedReduxOld?.openModalMarkerInfo?.open);

    useEffect(()=> {

        dispatch(setMapRoutesOptions({
            showDirectionsPanel: true
        }));   

        return() => {
            dispatch(setMapRoutesOptions({
                showDirectionsPanel: false
            }));
        }
    },[])

    useEffect(()=> {
        if(openModalMarkerInfo){
            dispatch(openModalRouteDirections({ open: false }))
        }
    },[openModalMarkerInfo])
    
    if(!openModal){
        return (<></>)
    } else {
        return (
            <SidePanel 
                isOpen={true} 
                onToggle={handleModalMaker} 
                hiddenButton={true} 
                style={{ width: '350px', transform: 'translateX(350px)' }} 
                position={"left"}
            >
                <SidePanelHeader>
                    <label className='label-title-print-route'>
                        {messages['fsmRoute_label_route_directions_title']}
                    </label>
                </SidePanelHeader>
                <SidePanelBody className='side-panel-body-routes'>
                    <div style={{
                        display: "flex",
                        flexDirection: "column",
                        justifyContent: "space-between",
                        alignItems: "center",
                        }}
                    >
                        <div className="scrollable-content">
                            <div style={{ maxHeight: '80vh', overflow: 'auto' }}>
                                <DirectionsMap id='modalDirectionsOnNewRoutes' />
                            </div>
                        </div>
                    </div> 
                </SidePanelBody>
                <SidePanelFooter>
                    <div style={{
                        display: "flex",
                        flexDirection: "row",
                        justifyContent: "space-between",
                        alignItems: "center",
                        }}
                    >
                        <Button
                            variant="secondary"
                            style={{ marginRight: 8 }}
                            onClick={() => {
                                dispatch(openModalRouteDirections({open: false, data: null}))
                            }}
                        >
                            {messages['fsmRoute_label_close']}
                        </Button>
                    </div>      
                </SidePanelFooter>
            </SidePanel>
            
        )
    }
}

export default ModalMarkerRouteDirections;

